const guidRegex = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/ig;

export function replaceGuid(value: string): string {
  return value.replace(guidRegex, '<guid>');
}
